import { useState, useEffect, useRef } from "react";
import LinkedInPost from "components/tweets/masonry/linkedinPost";
import { 
  useColorModeValue, 
  useMediaQuery, 
  Box, 
  Center, 
  Text,
  Heading,
  Divider,
  Stat,
  StatLabel,
  StatNumber,
  IconButton, Icon
} from "@chakra-ui/react";
import { formatTweetFromPost } from "../../utils/linkedinUtils";
import { CloseIcon } from "@chakra-ui/icons";
import { getPostsForDates } from './utils';
import PuffLoader from "react-spinners/PuffLoader";
import { motion } from "framer-motion";
import moment from "moment";
import { color, textStyle } from "theme/names";

const formatPost = (posts) => {
  const fPosts = posts.map((p) => {
    p.data = {
      ...p
    };
    return formatTweetFromPost(p);
  });
   return fPosts;
}

export const SeePostSlider = ({
  linkedInPosts = [],
  forDate = "",
  loading = true,
  mode = "personal",
  openSidebar = false,
  setOpenSidebar
}) => { 
    const [isLoading, setIsLoading] = useState<boolean>(loading);
    const [isTooSmall] = useMediaQuery("(max-width: 800px)");
    const [is1599] = useMediaQuery("(max-width: 1599px)");
    const sidebarBg = useColorModeValue("white", "#1E1E1E");
    const sidebarBorderColor = useColorModeValue(color["border.lightMode.light"], color["border.darkMode.light"]);
    // const statsCountColor = useColorModeValue("#1E1E1E","white");
    // const closeIconColor = useColorModeValue("gray.600", "whiteAlpha.300");
    const [isSidebarOpen, setIsSideBarOpen] = useState<boolean>(openSidebar);
    const [postDay, setPostDay] = useState(
      (moment(new Date(forDate))?.isValid()) 
      ?
        moment(new Date(forDate))?.format("MMM. Do ’YY")
      :
        forDate
    );
    const [postsOnDay, setPostsOnDay] = useState([] as any);
    const [isCalculatingPosts, setIsCalculatingPosts] = useState<boolean>(true);
    const containerRef = useRef(null);

    useEffect(() => {
      setIsLoading(loading);
    },[loading]);

    useEffect(() => {
      setIsSideBarOpen(openSidebar);
    },[openSidebar]);

    useEffect(() => {
      setIsCalculatingPosts(true);
       //@ts-ignore
      if(containerRef?.current?.scrollIntoView) containerRef?.current?.scrollIntoView({behavior: "smooth"});
      const postDayFormatted = 
        (moment(new Date(forDate))?.isValid())
        ?
          moment(new Date(forDate))?.format("MMM. Do ’YY")
        :
          forDate
        ;
      setPostDay(postDayFormatted);
      //@ts-ignore
      setPostsOnDay(formatPost(getPostsForDates(linkedInPosts,mode,{date: postDayFormatted})));
      setTimeout(() => {
        setIsCalculatingPosts(false);
      },600);
    },[linkedInPosts, forDate]);
    
    return (
      <motion.div
        animate={{
          width: isSidebarOpen ? (isTooSmall ? "100%" : "400px") : "0px",
          display: isSidebarOpen ? "block" : "none",
        }}
        transition={{ duration: 0.45 }}
        style={{
          zIndex: 9,
          //width: (isSidebarOpen) ? (isTooSmall ? "100%" : "400px") : "0px",
          overflow: "hidden scroll",
          position: isTooSmall ? "fixed" : "relative",
          minHeight: "100%",
          boxShadow: "rgba(100, 100, 111, 0.05) 0px 2px 19px 0px",
          maxWidth: "450px",
          display: isSidebarOpen ? "block" : "none",
        }}
        className="noScrollBar"
      >
        <Box
          width={isTooSmall ? "100%" : "400px"}
          position="fixed"
          height="100%"
          background={sidebarBg}
          borderLeft="1px"
          p="2"
          pl="4"
          borderColor={sidebarBorderColor}
          overflow="scroll"
          ref={containerRef}
          top="0"
          right={"0"}
        >
          <Box {...{ w: "full", pt: 4, pb: 0, alignSelf: "start" }}>
            <IconButton
              aria-label="Close"
              variant="action"
              size="table"
              mr={2}
              onClick={() => {
                // miscellaneousContext.setIsPersonSidebarOpen(false);
                // tweetContext.setIsOpen(!tweetContext.isOpen);
                setIsSideBarOpen(false);
                setOpenSidebar(false);
              }}
              icon={
                <Icon viewBox="0 0 14 11">
                  <svg
                    width="14"
                    height="11"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.12109 2.87891L10.1172 4.875H5.25C4.75781 4.875 4.375 5.28516 4.375 5.75C4.375 6.24219 4.75781 6.625 5.25 6.625H10.1172L8.12109 8.64844C7.95703 8.8125 7.875 9.03125 7.875 9.25C7.875 9.49609 7.95703 9.71484 8.12109 9.87891C8.44922 10.2344 9.02344 10.2344 9.35156 9.87891L12.8516 6.37891C13.207 6.05078 13.207 5.47656 12.8516 5.14844L9.35156 1.64844C9.02344 1.29297 8.44922 1.29297 8.12109 1.64844C7.76562 1.97656 7.76562 2.55078 8.12109 2.87891ZM2.625 10.125V1.375C2.625 0.910156 2.21484 0.5 1.75 0.5C1.25781 0.5 0.875 0.910156 0.875 1.375V10.125C0.875 10.6172 1.25781 11 1.75 11C2.21484 11 2.625 10.6172 2.625 10.125Z"
                      fill="currentColor"
                    />
                  </svg>
                </Icon>
              }
            />
            <Divider {...{ mt: 4 }}></Divider>
          </Box>
          {/* <Box textAlign="end" mt="2" mr="4">
            <CloseIcon
              color={closeIconColor}
              cursor="pointer"
              onClick={() => {
                setIsSideBarOpen(false);
                setOpenSidebar(false);
              }}
            />
          </Box> */}
          {!isCalculatingPosts && !isLoading && postsOnDay ? (
            <Box w={"100%"} pt={4}>
              <Text
                textStyle={textStyle["body.medium.light"]}
                // fontSize={"0.9rem"}
                // fontWeight={"bold"}
                // color={"gray.500"}
              >
                {postDay}
              </Text>
              <Text
                textStyle={textStyle["h4.bold.standard"]}
                // fontSize={"1.125rem"} fontWeight={"bold"}
                mb={"30"}
              >
                Posts of the day
              </Text>

              <Box display={"flex"} flexDir={"column"} ml={2} mt={12}>
                {postsOnDay.length <= 0 && (
                  <Text
                    textStyle={textStyle["body.medium.light"]}
                  >
                    No Posts for this day.
                  </Text>
                )}
                {postsOnDay.map((post, i) => {
                  return (
                    <Box pr={6} key={i}>
                      {/* 
                  // @ts-ignore */}
                      <LinkedInPost
                        tweet={post}
                        key={i}
                        disableUserPopup={true}
                      />
                      <Center pl={6}>
                        <Box
                          mt={7}
                          display={"flex"}
                          flexDirection={"row"}
                          flexWrap={"nowrap"}
                          w={"100%"}
                        >
                          <Stat w={"30%"}>
                            <StatLabel
                              textStyle={textStyle["body.medium.light"]}
                              // fontSize={"0.801rem"}
                              // fontWeight={"bold"}
                              // color={"gray.600"}
                              // textTransform={"uppercase"}
                            >
                              Reach
                            </StatLabel>
                            <StatNumber
                              textStyle={textStyle["body.medium.standard"]}
                              fontSize={"1.2rem"}
                              mt={1}
                              // fontWeight={"semibold"}
                              // color={statsCountColor}
                            >
                              {post?.numViews}
                            </StatNumber>
                          </Stat>
                          <Stat w={"30%"}>
                            <StatLabel
                              textStyle={textStyle["body.medium.light"]}
                              // fontSize={"0.801rem"}
                              // fontWeight={"bold"}
                              // color={"gray.600"}
                              // textTransform={"uppercase"}
                            >
                              Engagement
                            </StatLabel>
                            <StatNumber
                              textStyle={textStyle["body.medium.standard"]}
                              fontSize={"1.2rem"}
                              mt={1}
                              // fontWeight={"semibold"}
                              // color={statsCountColor}
                            >
                              {post?.totalEngagement}
                            </StatNumber>
                          </Stat>
                          <Stat w={"30%"}>
                            <StatLabel
                              textStyle={textStyle["body.medium.light"]}
                              // fontSize={"0.801rem"}
                              //           fontWeight={"bold"}
                              //           color={"gray.600"}
                              // textTransform={"uppercase"}
                            >
                              Engagement %
                            </StatLabel>
                            <StatNumber
                              textStyle={textStyle["body.medium.standard"]}
                              fontSize={"1.2rem"}
                              mt={1}
                              // fontWeight={"semibold"}
                              // color={statsCountColor}
                            >
                              {!post.numViews
                                ? 0
                                : (
                                    (post.totalEngagement * 100) /
                                    post.numViews
                                  ).toFixed(2) + "%"}
                            </StatNumber>
                          </Stat>
                        </Box>
                      </Center>
                      <Center>
                        <Divider
                          width="40"
                          borderBottomWidth="2px"
                          mb="50px"
                          mt="50px"
                        />
                      </Center>
                    </Box>
                  );
                })}
              </Box>
            </Box>
          ) : (
            <Center pt={10} h="200px">
              <PuffLoader
                color={"#0A66C2"}
                loading={isCalculatingPosts}
                size={50}
              />
            </Center>
          )}
        </Box>
      </motion.div>
    );
}
